import PropTypes from "prop-types";
import React from "react";
import InfoTooltipIcon from "~/components/shared/InfoTooltipIcon";

export const LabelWithIcon = ({ label, tooltip }) => {
  if (!tooltip) {
    return <>{label}</>;
  }

  const words = label.split(" ");
  const lastWord = words.pop();
  const leadingWords = words.join(" ");

  return (
    <>
      {leadingWords ? `${leadingWords} ` : null}
      <span className="text-nowrap">
        {lastWord}{" "}
        <InfoTooltipIcon
          ariaLabel={`What is ${label}?`}
          text={tooltip}
          placement="right"
          className="text-secondary"
        />
      </span>
    </>
  );
};

LabelWithIcon.propTypes = {
  label: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
};

export default LabelWithIcon;
